module.exports = __webpack_public_path__ + "static/media/robot-radical-italic.1a00ec1d.woff2";